module.exports = __webpack_public_path__ + "908d8eef8a21538f57df74f435e47922.svg";